function SearchController($element, $document, $mdConstant, $scope, $http, $sanitize) {

    var self = this;

    this.chosenItem = chosenItem;
    this.textChange = textChange;
    this.reset = reset;
    this.keydown = keydown;
    this.selectItem = selectItem;
    this.startDictation = startDictation;
    this.blur = blur;
    this.topProductString = topProductString;
    this.voiceIsEnabled = window.hasOwnProperty('webkitSpeechRecognition');

    this.searchTypes = {
        'all': 'All',
        'paym': 'Pay Monthly',
        'paymupgrade': 'Upgrades',
        'simonly': 'Sim Only',
        'simfree': 'Sim Free',
        'payg': 'Pay As You Go',
        'Accessory': 'Accessories'
    };

    this.showProducts = true;
    this.showCms = true;

    this.searchPosition = -1;
    this.searchLoading = false;

    this.results = [];
    this.searchType = 'all';

    if (!sessionStorage.getItem('animationCompleted')) {
        $document.ready(function() {
            this.txt = $element.find('#searchText').attr('placeholder');
            $element.find('#searchText').attr('placeholder', '');
            typeIt(this.txt, this.txt.length, 0);
        });
    }

    sessionStorage.setItem('animationCompleted', 1);

    function topProductString(productName, suffix) {
        var topProductString = $sanitize(productName);
        if (suffix) {
            topProductString = topProductString + ' in <strong>' + $sanitize(self.searchTypes[suffix]) + '</strong>';
        }
        return topProductString;
    }

    function blur(event) {
        if (!$(event.relatedTarget).parents('md-list-item').length) {
            this.searchFocus = false;
        }
    }

    function typeIt(string, length, char) {
        var humanize = Math.round(Math.random() * (150 - 30));
        if (char != length) {
            var timeOut = setTimeout(function() {
                char++;
                var type = string.substring(0, char);
                $element.find('#searchText').attr('placeholder', type + '|');
                typeIt(string, length, char);

                if (char == length) {
                    // remove the '|'
                    $element.find('#searchText').attr('placeholder', $element.find('#searchText').attr('placeholder').slice(0, -1));
                    clearTimeout(timeOut);
                }

            }, humanize);
        }
    }

    function chosenItem() {
        window.location = this.searchItem.value;
    }

    function textChange(query, dealType) {
        reset();
        self.safeSearchText = escape(query);
        if (!self.searchLoading) {
            self.searchLoading = true;
        }
        querySearch(query, dealType);
    }

    function reset() {
        self.searchPosition = -1;
        var elements = $element.find('md-list-item.searchItem');
        elements.find('div.md-button').removeClass('md-focused');
    }

    /**
     * Handles keyboard input.
     * @param event
     */
    function keydown(event) {
        this.elements = $element.find('md-list-item.searchItem');
        this.elementLength = this.elements.length;
        switch (event.keyCode) {
            case $mdConstant.KEY_CODE.DOWN_ARROW:
                event.stopPropagation();
                event.preventDefault();
                self.searchPosition = Math.min(self.searchPosition + 1, this.elementLength - 1);
                selectItem(self.searchPosition);
                break;
            case $mdConstant.KEY_CODE.UP_ARROW:
                if (this.loading) {
                    return;
                }
                event.stopPropagation();
                event.preventDefault();
                self.searchPosition = self.searchPosition < 0 ? this.elementLength - 1 : Math.max(0, self.searchPosition - 1);
                selectItem(self.searchPosition);
                break;
            case $mdConstant.KEY_CODE.TAB:
                this.searchFocus = false;
                break;
            case $mdConstant.KEY_CODE.ENTER:
                if (self.searchPosition == -1 && self.resultCount) {
                    window.location.href = $(this.elements[0]).attr('href');
                }
                if ($(this.elements[self.searchPosition]).attr('href')) {
                    window.location.href = $(this.elements[self.searchPosition]).attr('href');
                }
                break;
            default:
        }
    }

    function selectItem(pos) {
        self.elements.find('div.md-button').removeClass('md-focused');
        $(self.elements).eq(pos).find('div.md-button').addClass('md-focused');
        var scrollPos = $(self.elements).eq(pos).position().top;
        $('#searchResults').find('md-content').scrollTop(scrollPos + $('#searchResults').find('md-content').scrollTop());
    }

    function startDictation() {
        if (window.hasOwnProperty('webkitSpeechRecognition')) {
            var recognition = new webkitSpeechRecognition();
            recognition.continuous = false;
            recognition.interimResults = false;

            recognition.lang = 'en-GB';

            recognition.start();

            recognition.onresult = function(e) {
                $scope.$apply(function() {
                    self.searchText = e.results[0][0].transcript;
                    self.searchFocus = true;
                    textChange(self.searchText, self.searchType);
                });
                recognition.stop();
                self.SW9.stop();
            };

            recognition.onerror = function() {
                recognition.stop();
            };
            recognition.onstart = function() {
                self.SW9.start();
                jQuery('body').addClass('dictation-active');
            };
            recognition.onend = function() {
                self.SW9.stop();
                jQuery('body').removeClass('dictation-active');
            };

        }
    }

    function querySearch(query, dealType) {
        var data = {
            query: query,
            dealType: dealType
        };

        return $http.get('/search', {
            params: data
        }).then(
            function(response) {
                self.resultCount = 0;
                angular.forEach(response.data, function(value, key) {
                    if (value.length) {
                        self.resultCount = self.resultCount + value.length;
                    }
                    this[key] = value;
                }, self.results);

                addGatSearchLayer(data);
                self.searchLoading = false;
            },
            function() {
                self.error = true;
                self.globalDisabled = true;
            }
        );
    }

    function addGatSearchLayer(data) {
        dataLayer.push({
            event: 'siteSearch',
            siteSearchTerm: data.query,
            siteSearchCategory: data.dealType,
            siteSearchResultsCount: self.resultCount
        });
    }

    function searchHeaderToggle(searchHeader) {
        $(searchHeader).on('click', function() {
            $('body').toggleClass('header-search-active');
        });
    }

    self.SW9 = new SiriWave9({
        width: 450,
        height: 330,
        speed: 0.1,
        amplitude: 1,
        container: document.getElementById('dictation-display-inner'),
        autostart: false
    });
    searchHeaderToggle("a[data-target='#search']");
}

SearchController.$inject = ['$element', '$document', '$mdConstant', '$scope', '$http', '$sanitize'];

var SearchComponents = angular.module('Search.components', ['ngSanitize']);

SearchComponents.component('search', {
    templateUrl: 'cdtsearch/templates/search.html',
    controller: SearchController,
    controllerAs: 'ctrl'
});
